// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__fLVTV","actions":"GroupTable_actions__2ndpC","deleteModalFooter":"GroupTable_deleteModalFooter__3KKA6"};